function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.59 4.59009L8 9.17009L3.41 4.59009L2 6.00009L8 12.0001L14 6.00009L12.59 4.59009Z",
  fill: "#979797"
});

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  maskUnits: "userSpaceOnUse",
  x: 2,
  y: 4,
  width: 12,
  height: 8
}, React.createElement("path", {
  d: "M12.59 4.59009L8 9.17009L3.41 4.59009L2 6.00009L8 12.0001L14 6.00009L12.59 4.59009Z",
  fill: "white"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0)"
}, React.createElement("rect", {
  x: -4,
  y: -4,
  width: 24,
  height: 24,
  fill: "#979797"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/expand_more.57bcd783.svg";
export { SvgComponent as ReactComponent };